<template>
  <div class="recomlayadv">
    <sub-title class="rclatitle" :text="titletext" />
    <div class="rclalist">
      <div class="rclaitem flex_start" v-for="item in xhnum" :key="item">
        <div class="cover">
          <img src="../../../assets/jpcol/smallrentou_sample.png" alt="" />
        </div>
        <div class="inf">
          <div class="name">王家政律师</div>
          <div class="tag">
            <span>刑事诉讼</span>
            <span>离婚案件</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from 'views/home/components/subTitle'
export default {
  components:{
    subTitle
  },
  props:{
    titletext:{
      type:String,
      default:'合肥民商法律师推荐'
    },
    xhnum:{
      type:Number,
      default:4
    }
  }
};
</script>

<style lang="scss" scoped>
.recomlayadv {
  padding: 32px 0 0;
  .rclatitle {
    margin-left: 12px;
  }
  .rclalist {
    padding: 0 15px 0 22px;
    .rclaitem {
      margin-top: 30px;
      .cover {
        img {
          width: 84px;
          height: 84px;
        }
      }
      .inf {
        margin-left: 16px;
        .name {
          font-size: 18px;
          color: #333333;
        }
        .tag {
          font-size: 12px;
          margin-top: 10px;
          color: #3e8fff;
          span {
            padding: 1px 5px;
            border: 1px solid #3e8fff;
            border-radius: 5px;
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>